import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { scrollToId } from '@/lib/scroll';
import { useSeo } from '@/lib/seo';

export default function PlaceholderPage({ title, notFound = false }) {
  useSeo({
    title: `${title} | Amden Group`,
    description: notFound
      ? 'The page you are looking for does not exist. Return to the Amden Group homepage or get in touch.'
      : 'This Amden Group page is part of the next stage of the website build.',
    robots: 'noindex',
  });
  return (
    <section className="bg-mist py-24 sm:py-32" data-testid="placeholder-page">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold-700">
          {notFound ? '404' : 'Coming soon'}
        </p>
        <h1 className="mt-4 text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
          {title}
        </h1>
        <p className="mt-4 text-base leading-relaxed text-slate-600">
          {notFound
            ? 'The page you’re looking for doesn’t exist. Let’s get you back on track.'
            : 'This page is part of the next stage of the Amden Group website build. In the meantime, tell us about your business and we’ll point you in the right direction.'}
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            data-testid="placeholder-home-link"
            className="group inline-flex items-center justify-center gap-2 rounded-md border-2 border-navy-900 px-6 py-3 text-sm font-bold text-navy-900 transition-colors hover:bg-navy-900 hover:text-white"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Back to homepage
          </Link>
          <Link
            to="/#solution-finder"
            data-testid="placeholder-get-started-link"
            className="group inline-flex items-center justify-center gap-2 rounded-md bg-navy-900 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-navy-700"
          >
            Get Started
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}
